module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    staticClass: "userform",
    attrs: {
      "md-align": "center"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isAuth) ? _c('experiment-choice') : _c('md-card', {
    staticClass: "user-form-card",
    attrs: {
      "md-with-hover": ""
    }
  }, [_c('md-card-content', [_c('md-tabs', [_c('md-tab', {
    attrs: {
      "id": "signin-tab",
      "md-label": "Sign In"
    }
  }, [_c('form', {
    staticClass: "user-form",
    attrs: {
      "id": "login_form"
    },
    on: {
      "submit": _vm.performLogin
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Login")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "Login",
      "name": "login",
      "required": ""
    },
    model: {
      value: (_vm.login),
      callback: function($$v) {
        _vm.login = $$v
      },
      expression: "login"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "Password",
      "name": "password",
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Sign In")])], 1)]), _vm._v(" "), _c('md-tab', {
    attrs: {
      "id": "register-tab",
      "md-label": "Register"
    }
  }, [_c('form', {
    staticClass: "user-form",
    attrs: {
      "id": "register_form"
    },
    on: {
      "submit": _vm.performRegister
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Username")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "Username",
      "name": "username",
      "required": ""
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "Email",
      "name": "email",
      "type": "email",
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "Password",
      "name": "password1",
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.password1),
      callback: function($$v) {
        _vm.password1 = $$v
      },
      expression: "password1"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Repeat Password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "Repeat Password",
      "name": "password2",
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.password2),
      callback: function($$v) {
        _vm.password2 = $$v
      },
      expression: "password2"
    }
  })], 1), _vm._v(" "), _c('md-checkbox', {
    attrs: {
      "id": "terms-checkbox",
      "name": "terms",
      "required": ""
    }
  }), _vm._v(" I agree to "), _c('a', {
    attrs: {
      "href": "/static/Terms_and_conditions.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Terms and Conditions")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Create Account")])], 1)])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f4d6e08"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserForm.vue
// module id = 338
// module chunks = 1